import { render, staticRenderFns } from "./CreateReceivingModel.vue?vue&type=template&id=c902e85e&"
import script from "./CreateReceivingModel.vue?vue&type=script&lang=js&"
export * from "./CreateReceivingModel.vue?vue&type=script&lang=js&"
import style0 from "./CreateReceivingModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports